import React, { useContext, useEffect } from "react";

import { Preview } from "@creatomate/preview";

import { CreatomateContext } from "../../../contexts/VideoStudioContext";
import DeleteButton from "../../../common/DeleteButton";
import Title from "./Title";
import UploadAudio from "./UploadAudio";
import SelectAudio from "./SelectAudio";
import AudioFields from "./AudioFields";
import AudioOptions from "./AudioOptions";

interface AudioProps {
  preview: Preview;
}

const Audio: React.FC<AudioProps> = ({ preview }) => {
  const { getActiveElement } = useContext(CreatomateContext);
  const { ready, state } = preview;
  const { elements } = state || { elements: [] };
  const activeElement = getActiveElement(preview);

  useEffect(
    () => {
      if (ready) {
        const audioElement = elements?.find(element => element.source.type === "audio");
        if (activeElement?.source?.type !== "audio" && audioElement?.source?.id) {
          preview.setActiveElements([audioElement.source.id]);
        }
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ready]
  );

  return (
    <>
      <div className="Captions-Header__Title">
        <div className="Captions-Header__Actions">
          <Title activeElement={activeElement} />
          {activeElement?.source?.type === "audio" && (
            <DeleteButton element={activeElement} preview={preview} />
          )}
        </div>
        {activeElement?.source?.type === "audio" ? (
          <SelectAudio preview={preview} />
        ) : (
          <UploadAudio preview={preview} />
        )}
      </div>
      {activeElement?.source?.type === "audio" ? (
        <AudioFields activeElement={activeElement} preview={preview} />
      ) : (
        <AudioOptions preview={preview} />
      )}
    </>
  );
};

export default Audio;
